import React, { Component } from "react";
import {
  handleStepParam,
  handleStep,
  handleIconValues
} from "./../Utils/steps";
import { checkParams } from "./../Utils";
import queryString from "query-string";
import { __ROOTPATH__ } from "./../../services/db";
import Features from "./../layout/Features";
import CustomPackage from "./StepCustomPackage/CustomPackage";
import Footer from "./../layout/Footer";
import ReactGA from "react-ga";

export class StepCustomPackage extends Component {
  state = {
    step: null,
    stepParamURL: 0,
    selectedRowIcon: null,
    selectedRowIconPrev: null,
    selectedRowIconIndex: null,
    selectedRowIconIndexPrev: null
  };

  componentDidMount() {
    this.handleStep();
  }

  handleStep = () => {
    const { stepParamURL, wizardData, steps } = this.props;
    const stepData = handleStep(
      this.props,
      stepParamURL,
      wizardData,
      steps,
      null
    );

    if (stepData) {
      stepData.then(data => {
        const step = data[0];
        this.setState({
          step,
          stepParamURL
        });
      });
    }
  };

  handleStepParam = (ev, stepParamURL, props) => {
    const { history } = props;

    const newStepValue = handleStepParam(ev, stepParamURL, props);

    history.push(newStepValue);
  };

  handleSelectIconRow = ev => {
    const { history } = this.props;

    const nextStep = handleIconValues(
      "step-custom-icon-row",
      ev.target.value,
      this.props,
      this.state.selectedRowIconPrev
    );

    this.setState({
      selectedRowIconPrev: ev.target.value,
      selectedRowIcon: ev.target.value
    });

    if (nextStep) {
      history.push(nextStep);

      if (ev.target.value === "empty") {
        const iconValue = {
          target: {
            value: "empty"
          }
        };
        this.handleSelectIconIndex(iconValue);
      }
    }
  };

  handleSelectIconIndex = ev => {
    const { history } = this.props;

    const nextStep = handleIconValues(
      "step-custom-icon-index",
      ev.target.value,
      this.props,
      this.state.selectedRowIconIndexPrev
    );

    this.setState({
      selectedRowIconIndexPrev: ev.target.value,
      selectedRowIconIndex: ev.target.value
    });

    if (nextStep) {
      history.push(nextStep);
    }
  };

  render() {
    const { props, stepParamURL, location, history, wizardData } = this.props;
    const { step, selectedRowIcon } = this.state;

    const stepCustomIconRowValue =
      location && checkParams("step-custom-icon-row", location);
    const stepCustomIconIndexRowValue =
      location && checkParams("step-custom-icon-index", location);
    const message = location && checkParams(`step${stepParamURL}`, location);

    const paramsURL = queryString.parse(props.location.search);

    const primaryColorSelected =
      location && checkParams("primary-color", location);
    const secondaryColorSelected =
      location && checkParams("secondary-color", location);
    const tertiaryColorSelected =
      location && checkParams("tertiary-color", location);
    const colorRowIndex = tertiaryColorSelected[0];
    const colorColIndex = tertiaryColorSelected[2];

    const colorSelected =
      wizardData.colors[parseInt(primaryColorSelected)]
        .wizard_colors_secondary_repeater[parseInt(secondaryColorSelected)]
        .wizard_colors_tertiary_repeater_row[colorRowIndex]
        .wizard_colors_tertiary_repeater[colorColIndex]
        .wizard_color_tertiary_picker;

    let sendToCartURL = null;

    if (location) {
      const wizardId = location.pathname.replace("/", "");
      const searchURLValues = location.search.replace("?", "");
      sendToCartURL = `wizard=${wizardId}&${searchURLValues}`;
    }

    const actualStepValue = paramsURL[`step${stepParamURL}`];
    const selectedIconImageURL =
      step &&
      stepCustomIconIndexRowValue &&
      step.iconsRepeater[
        selectedRowIcon ? selectedRowIcon : stepCustomIconRowValue
      ] &&
      step.iconsRepeater[
        selectedRowIcon ? selectedRowIcon : stepCustomIconRowValue
      ].wizard_step_customizer_icons_repeater[stepCustomIconIndexRowValue] &&
      step.iconsRepeater[
        selectedRowIcon ? selectedRowIcon : stepCustomIconRowValue
      ].wizard_step_customizer_icons_repeater[stepCustomIconIndexRowValue]
        .wizard_step_customizer_icons_image;

    return (
      <div>
        <div className="row mg-left-0 mg-right-0 set-height">
          <div className="col-12 col-md-6 p-0">
            <div style={{ position: "relative" }}>
             <div className="fixed-side">
              <CustomPackage
                message={message}
                selectedIconImageURL={selectedIconImageURL}
                colorSelected={colorSelected}
              />
              <div className="FooterWrap">
                <Footer location={location} history={history} />
              </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 wizard-col-steps socket-holder">
            <h1 className="d-none d-md-block header-step">
              Haz que tu lipstick sea único
            </h1>
            <h6 className="text-uppercase font-weight-700 font-size-14px mb-4">
              Personaliza el packaging por solo 1 €
            </h6>
            <div className="row mb-4 align-items-center">
              <div className="col-1 col-sm-1">
                <p className="text-secondary font-weight-bolder font-size-10">
                  1.
                </p>
              </div>
              <div className="col-8 col-sm-9 col-lg-7">
                <input
                  onChange={ev => this.handleStepParam(ev, stepParamURL, props)}
                  className="form-control"
                  type="text"
                  alt="Nombre del paquete"
                  maxLength="10"
                  placeholder="Escribe un mensaje"
                  defaultValue={
                    actualStepValue === "empty" ? "" : actualStepValue
                  }
                />
              </div>
              <div className="col-3 col-sm-2 col-lg-4">
                <p className="text-secondary mb-0 limit-wizard">
                  {actualStepValue ? 10 - actualStepValue.length : "10"}{" "}
                  {actualStepValue && 10 - actualStepValue.length === 1
                    ? "letra"
                    : "letras"}
                </p>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-1">
                <p className="text-secondary font-weight-bolder font-size-10">
                  2.
                </p>
              </div>
              <div className="col-11">
                <select
                  onChange={this.handleSelectIconRow}
                  className="form-control"
                  value={
                    selectedRowIcon
                      ? selectedRowIcon.toString()
                      : stepCustomIconRowValue
                      ? stepCustomIconRowValue
                      : undefined
                  }
                >
                  <option value="empty">Elige un motivo, un icono...</option>
                  {step &&
                    step.iconsRepeater &&
                    step.iconsRepeater.map((iconRepeater, index) => {
                      return (
                        <option key={index} value={index}>
                          {iconRepeater.wizard_step_customizer_title_category}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="col-12">
                <div className="card-wizard m-0">
                  <div className="wizard-app-radio">
                    <div className="">
                      <div className="row icons-grid">
                        {step &&
                          step.iconsRepeater &&
                          step.iconsRepeater[
                            selectedRowIcon
                              ? selectedRowIcon
                              : stepCustomIconRowValue
                          ] &&
                          step.iconsRepeater[
                            selectedRowIcon
                              ? selectedRowIcon
                              : stepCustomIconRowValue
                          ].wizard_step_customizer_icons_repeater &&
                          step.iconsRepeater[
                            selectedRowIcon
                              ? selectedRowIcon
                              : stepCustomIconRowValue
                          ].wizard_step_customizer_icons_repeater.map(
                            (data, index) => {
                              return (
                                <div
                                  className="col-3"
                                  key={
                                    data.wizard_step_customizer_icons_image +
                                    index
                                  }
                                >
                                  <div
                                    className={`card card-t1 card-radio ${parseInt(
                                      stepCustomIconIndexRowValue
                                    ) === index && "active"}`}
                                  >
                                    <img
                                      src={
                                        data.wizard_step_customizer_icons_image
                                      }
                                      alt="Icono"
                                    />
                                    <input
                                      checked={
                                        parseInt(
                                          stepCustomIconIndexRowValue
                                        ) === index
                                          ? true
                                          : false
                                      }
                                      value={index}
                                      type="radio"
                                      name="selectIcon"
                                      onChange={this.handleSelectIconIndex}
                                    />
                                  </div>
                                </div>
                              );
                            }
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="end-wizard">
              <ReactGA.OutboundLink
                eventLabel="Finalizar compra"
                className="btn button-finish-purchase btn-red btn-lg btn-fixedbottom"
                to={`${__ROOTPATH__}/carrito?${sendToCartURL}&from-wizard=true`}
                target="_self"
              >
                Finalizar compra
              </ReactGA.OutboundLink>
            </div>
            <Features route={this.props} />
          </div>
        </div>
      </div>
    );
  }
}

export default StepCustomPackage;
